import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
const getDefaultPageLayoutName = pathname => {
  if (!pathname) {
    return 'Default';
  }

  // Remove leading slash for comparison
  const cleanPathname = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  if (cleanPathname === 'cart' || cleanPathname === 'checkout' || cleanPathname === 'thank-you' || cleanPathname.startsWith('cart') || cleanPathname.startsWith('checkout')) {
    return 'ConsumerWithoutHeaderAndFooter';
  }
  return 'Default';
};
const usePageLayoutName = () => {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = getDefaultPageLayoutName(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const defaultPageLayoutName = t0;
  return defaultPageLayoutName;
};
export default usePageLayoutName;